import React from 'react';

const FAQTableSkeleton = () => {
  return Array.from({ length: 6 }).map((_, i) => (
    <tr key={i} className="animate-pulse">
      <td className="px-5 py-4"><div className="h-3 w-4 bg-gray-200 rounded" /></td>
      <td className="px-5 py-4">
        <div className="space-y-1.5">
          <div className="h-3 w-48 bg-gray-200 rounded" />
          <div className="h-3 w-36 bg-gray-200 rounded" />
        </div>
      </td>
      <td className="px-5 py-4">
        <div className="space-y-1.5">
          <div className="h-3 w-64 bg-gray-200 rounded" />
          <div className="h-3 w-48 bg-gray-200 rounded" />
        </div>
      </td>
      <td className="px-5 py-4"><div className="h-3 w-16 bg-gray-200 rounded" /></td>
      <td className="px-5 py-4">
        <div className="flex gap-2">
          <div className="h-7 w-14 bg-gray-200 rounded-lg" />
          <div className="h-7 w-14 bg-gray-200 rounded-lg" />
        </div>
      </td>
    </tr>
  ));
};

export default FAQTableSkeleton;